import { all, call, fork, put, takeLatest, getContext } from 'redux-saga/effects';
import { reinviteUser, resetPassword } from '../../api/api';
import * as actions from './actions';
import { logout } from '../auth/actions';
import { UserActionTypes } from './types';
import _isTesting from '../../utilities/isTesting';

function* handleReinviteUser(action: ReturnType<typeof actions.reinviteUser>) {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired - handleReinviteUser');
      return;
    }
    const { uniId, username, pathway } = action.payload;

    if (!uniId) {
      throw new Error('University Id is missing or the value is empty');
    }

    const response = yield call(reinviteUser, idToken, uniId, username, pathway);

    if (response.name === 'Error') {
      throw new Error(response.stack);
    }

    yield put(actions.reinviteUserSuccess(response));
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.reinviteUserFailure(err.message));
    } else {
      yield put(actions.reinviteUserFailure('An unknown error occured.'));
    }
  }
}

function* handleResetUser(action: ReturnType<typeof actions.reinviteUser>) {
  try {
    const context = yield getContext('sagaContext');
    const idToken: any = yield call(context.getIdToken);
    if (!idToken) {
      yield put(logout());
      yield call(context.onLogout);
      console.log('Refresh Token has Expired - handleResetUser');
      return;
    }
    const { uniId, username, pathway } = action.payload;

    if (!uniId) {
      throw new Error('University Id is missing or the value is empty');
    }

    const response = yield call(resetPassword, idToken, uniId, username, pathway);

    if (response.name === 'Error') {
      throw new Error(response.stack);
    }

    yield put(actions.resetPasswordSuccess(response));
  } catch (err) {
    if (err instanceof Error) {
      yield put(actions.resetPasswordFailure(err.message));
    } else {
      yield put(actions.resetPasswordFailure('An unknown error occured.'));
    }
  }
}

function* watchResendInvite() {
  yield takeLatest(UserActionTypes.REINVITE_USER, handleReinviteUser);
}

function* watchResetUser() {
  yield takeLatest(UserActionTypes.RESET_USER, handleResetUser);
}

function* UserSaga() {
  yield all([fork(watchResendInvite)]);
  yield all([fork(watchResetUser)]);
}

export default UserSaga;
